import React, { useContext, useEffect, useRef, useState } from 'react';
import LeftRightSplit from '../../../../ui/LeftRightSplit';
import SecondaryButton from '../../../../ui/SecondaryButton';
import InlineInputControlRow from '../../../../ui/layout/InlineInputControlRow';
import TextBox from '../../../../ui/TextBox';
import Label from '../../../../ui/Label';
import InlineInputControlRowNoLabel from '../../../../ui/layout/InlineInputControlRowNoLabel';
import CheckBox from '../../../../ui/CheckBox';
import LabeledSelect from '../../../../ui/LabeledSelect';
import { ApplicableTableSettings } from '../../../../tableSettings';
import useTableStorage from '../../../../hooks/useTableStorage';
import { amsUserPortTable, amsUserScacTable } from '../tableSettings';
import SmartTable from '../../../../uiControls/SmartTable';
import TextBoxUncontrolled from '../../../../ui/TextBoxUncontrolled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { AmsUser } from '../../../../framework.core/AmsUser';
import ApplicationContext from '../../../../ApplicationContext';
import { useTypedFastStorage } from '../../../../hooks/useFastStorage';
import _ from 'lodash';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';


const findButtonStyle:React.CSSProperties = {
  width: '100%',
  borderTop: '1px solid black',
  borderRight: '1px solid black',
  borderBottom: '1px solid black',
}

const findTextBoxStyle: React.CSSProperties = {
  display: 'block',
  float: 'left',
  width: '100%',
  paddingRight: '35px',
  height: '18px',
};

const findIconStyle: React.CSSProperties = {
  cursor: 'pointer',
  position: 'absolute',
  right: '5px',
  top: '3px',
};

interface ViewUserStorageKeys {
  modelStorage: string,
};

interface ViewUserParams {
  id: string | undefined,
  mode: string,
  onPopupClose?: () => void,
};

interface ViewUserLoadedDetailsViewParams {
  user: AmsUser,
  isView: boolean,
  onPopupClose?: () => void
};

function getViewUserStorageKeys(): ViewUserStorageKeys {
  return {modelStorage: 'oi-ams-user'}
}

function ViewUserImpl(params: ViewUserParams) {
  const {id, onPopupClose} = params;
  const {modelStorage} = getViewUserStorageKeys();
  const [inStorage, setInStorage, removeUserFromStorage] = useTypedFastStorage<AmsUser>(modelStorage, null);
  const appContext = useContext(ApplicationContext);

  useFunctionKeys({onEsc: cancel});

  function cancel() {
    if(onPopupClose) onPopupClose();
    return true;
  }
  
  useEffect(() => {
    initialize();
    return () => {
      removeUserFromStorage()
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []
);

async function loadExisting() {
  const apiResult = await appContext.api.getAmsUser(id);
  if(apiResult && apiResult.success) {
    let data: AmsUser = new AmsUser(apiResult.result);
    return data;
  }
  return {}
}

async function initialize() {
  const data = await loadExisting();
  setInStorage(_.cloneDeep(data));
}

if (!inStorage) {
  return null;
}

  return (
    <ViewUserImplInitializedImpl 
      user={inStorage} 
      isView={params.mode === 'view'} 
      onPopupClose={params.onPopupClose}
    />
  );
}

function ViewUserImplInitializedImpl({
  user,
  isView,
  onPopupClose
}: ViewUserLoadedDetailsViewParams) {
  const [userRef, setUserRef] = useState<AmsUser>(user);
  const [dirty, setDirty] = useState(false);

  const portSearchRef = useRef<HTMLInputElement>(null);
  const scacSearchRef = useRef<HTMLInputElement>(null);

  const tableStorage = useTableStorage();

  function onChange(change: Partial<AmsUser>) {
    const eur = _.cloneDeep(_.merge(userRef, change));

    setUserRef(eur);
    if (!dirty) {
      setDirty(true);
    }
  }

  const portLeftTableOptions: ApplicableTableSettings = {
    tableName: 'portLeftTable',
    ...amsUserPortTable,
    data: [],
    rowRenderers: [
    ],
    customStorage: tableStorage,
    headersColor: 'gray',
    height: '120px'
  };

  const portRightTableOptions: ApplicableTableSettings = {
    tableName: 'portRightTable',
    ...amsUserPortTable,
    data: [],
    rowRenderers: [
    ],
    customStorage: tableStorage,
    headersColor: 'gray',
    height: '120px'
  };

  const scacLeftTableOptions: ApplicableTableSettings = {
    tableName: 'sacLeftTable',
    ...amsUserScacTable,
    data: [],
    rowRenderers: [
    ],
    customStorage: tableStorage,
    headersColor: 'gray',
    height: '120px'
  };

  const scacRightTableOptions: ApplicableTableSettings = {
    tableName: 'scacRightTable',
    ...amsUserScacTable,
    data: [],
    rowRenderers: [
    ],
    customStorage: tableStorage,
    headersColor: 'gray',
    height: '120px'
  };

  function handlePortSearch() {

  }

  function handleScacSearch() {
    
  }

  return (
    <div className='report-popup'>
      <div style={{display: 'flex', borderBottom: '2px solid black', marginBottom: '20px'}}>
        <div>
          <div style={{width: '320px', display: 'flex'}}>
            <div style={{width: '160px'}}>
              <InlineInputControlRow mode="w80" smallMargin label="User Id">
                <TextBox value={userRef.userID} disabled={isView} onChange={e => onChange({userID: e.target.value})} />
              </InlineInputControlRow>

              <InlineInputControlRow mode="w80" smallMargin label="Ams Group">
                <TextBox value={userRef.amsGroupName} disabled={isView} onChange={e => onChange({amsGroupName: e.target.value})} />
              </InlineInputControlRow>
            </div>

            <div style={{width: '160px'}}>
              <InlineInputControlRow mode="w80" smallMargin label={<div style={{textAlign: 'right', marginRight: '10px'}}>Password</div>}>
                <TextBox value={userRef.password} disabled={isView} onChange={e => onChange({password: e.target.value})} />
              </InlineInputControlRow>

              <InlineInputControlRow mode="w80" smallMargin label={<div style={{textAlign: 'right', marginRight: '10px'}}>Branch</div>}>
                <TextBox value={userRef.amsSubGroup} disabled={isView} onChange={e => onChange({amsSubGroup: e.target.value})} />
              </InlineInputControlRow>
            </div>
          </div>

          <InlineInputControlRowNoLabel>
            <div style={{marginLeft: '5px'}}>
              <CheckBox value={userRef.active} disabled={isView} label="Active" onChange={active => onChange({active})} />
            </div>
          </InlineInputControlRowNoLabel>
        </div>

        <div style={{width: '320px', marginLeft: '40px'}}>
          <InlineInputControlRow mode="smaller-2x" smallMargin label="Name">
            <TextBox value={userRef.name} disabled={isView} onChange={e => onChange({name: e.target.value})} />
          </InlineInputControlRow>

          <InlineInputControlRow mode="smaller-2x" smallMargin label="Email">
            <TextBox value={userRef.email} disabled={isView} onChange={e => onChange({email: e.target.value})} />
          </InlineInputControlRow>
        </div>
      </div>

      <div style={{display: 'flex', marginBottom: '40px'}}>
        <div style={{width: '320px'}}>
          <LeftRightSplit
            leftSize="120px"
            rightSize="calc(100% - 120px)"
            left={<Label label="Port List" />}
            right={
              <div style={{float: 'right'}}>
                <LabeledSelect
                  label="Select First Letter"
                  labelSize="100px"
                  items={[]}
                  value={''}
                  disabled={isView}
                />
              </div>
            }
          />

          <div style={{marginLeft: '90px'}}>
            <SmartTable {...portLeftTableOptions} />
            <div style={{marginRight: '20px'}}>
              <LeftRightSplit
                leftSize="calc(100% - 45px)"
                rightSize="45px"
                left={
                  isView ? 
                  <div style={{position: 'relative'}}>
                    <TextBoxUncontrolled ref={portSearchRef} onEnter={handlePortSearch} style={findTextBoxStyle} disabled />
                    <FontAwesomeIcon color='#a1a1a1' icon={faSearch} style={findIconStyle} />
                  </div> :
                  <div style={{position: 'relative'}}>
                  <TextBoxUncontrolled ref={portSearchRef} onEnter={handlePortSearch} style={findTextBoxStyle} />
                  <FontAwesomeIcon color='#a1a1a1' icon={faSearch} onClick={handlePortSearch} style={findIconStyle} />
                </div> 
                }
                right={
                  <SecondaryButton size="extrasmall" disabled={isView} onClick={handlePortSearch} style={findButtonStyle}>Find</SecondaryButton>
                }
              />
            </div>
          </div>

        </div>

        <div style={{width: '230px', marginLeft: '40px', marginTop: '22px'}}>
          <SmartTable {...portRightTableOptions} />
        </div>
      </div>

      <div style={{display: 'flex'}}>
        <div style={{width: '320px'}}>
          <LeftRightSplit
            leftSize="120px"
            rightSize="calc(100% - 120px)"
            left={<Label label="SCAC List" />}
            right={
              <div style={{float: 'right'}}>
                <LabeledSelect
                  label="Select First Letter"
                  labelSize="100px"
                  items={[]}
                  value={''}
                  disabled={isView}
                />
              </div>
            }
          />

          <div style={{marginLeft: '90px'}}>
            <SmartTable {...scacLeftTableOptions} />
            <div style={{marginRight: '20px'}}>
              <LeftRightSplit
                leftSize="calc(100% - 45px)"
                rightSize="45px"
                left={
                  isView ? 
                  <div style={{position: 'relative'}}>
                    <TextBoxUncontrolled ref={scacSearchRef} onEnter={handleScacSearch} style={findTextBoxStyle} disabled />
                    <FontAwesomeIcon color='#a1a1a1' icon={faSearch} style={findIconStyle} />
                  </div> :
                  <div style={{position: 'relative'}}>
                  <TextBoxUncontrolled ref={scacSearchRef} onEnter={handleScacSearch} style={findTextBoxStyle} />
                  <FontAwesomeIcon color='#a1a1a1' icon={faSearch} onClick={handleScacSearch} style={findIconStyle} />
                </div> 
                }
                right={
                  <SecondaryButton size="extrasmall" disabled={isView} onClick={handleScacSearch} style={findButtonStyle}>Find</SecondaryButton>
                }
              />
            </div>
          </div>

        </div>

        <div style={{width: '230px', marginLeft: '40px', marginTop: '22px', marginBottom: '20px'}}>
          <SmartTable {...scacRightTableOptions} />
        </div>
      </div>

      <div className='clearfix'/>
      <div className='report-footer'>
        <SecondaryButton
          size="regular"
          name='amsUser-detail-cancel-button'
          onClick={onPopupClose}>
          CANCEL
        </SecondaryButton>
      </div>
    </div>
  );
}

const ViewUser = ({selectedElementId, mode, onPopupClose}: { selectedElementId: string, mode: string, onPopupClose?: () => void }) => {

  return (
    <ViewUserImpl id={selectedElementId} mode={mode} onPopupClose={onPopupClose} key={`viewUser-details`}/>
  );
};
export default ViewUser;
